// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '7b7f7b33b7d14697bef7fb3a1b7f8b2b62525ed5';
export const BUILD_NUMBER = '230';
export const BUILD_TIMESTAMP = '2026-09-08T10:42:47.610Z';
